export const isDistributorRole = (role?: string | null) => role === 'distributor';

export const isCommercialRole = (role?: string | null) => (
  role === 'commercial' || role === 'admin' || role === 'beeadmin'
);

export const getOperatorBasePath = (role?: string | null) => (
  isDistributorRole(role) ? '/distributor' : '/commercial'
);

export const getOperatorPanelLabel = (role?: string | null) => (
  isDistributorRole(role) ? 'Panel distribuidor' : 'Panel comercial'
);

export const getOperatorSubtitle = (role?: string | null) => (
  isDistributorRole(role) ? 'Clientes finales y envíos directos' : 'Gestión comercial'
);

export const getPrivateCustomersLabel = (role?: string | null) => (
  isDistributorRole(role) ? 'Clientes finales' : 'Clientes privados'
);

export const getPrivateCustomersDescription = (role?: string | null) => (
  isDistributorRole(role)
    ? 'Gestiona los destinatarios para envíos directos'
    : 'Gestiona tus clientes privados'
);
